import { styled, makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Container = styled(Box)({
  width: '100%',
});

export const TopBar = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px',
  gap: '16px',
  flexWrap: 'wrap',
});

export const useStyles = makeStyles(theme => ({
  tableContainer: {
    background: theme.colors.backgroundLight,
    borderRadius: theme.borderRadius,
    padding: '16px',
  },
  chipActive: {
    backgroundColor: theme.colors.win,
    color: '#fff',
  },
  chipTrial: {
    backgroundColor: theme.colors.primary,
    color: '#1E2141',
  },
  chipInactive: {
    backgroundColor: theme.colors.loss,
    color: '#fff',
  },
  searchField: {
    minWidth: '250px',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '12px',
    minWidth: '350px',
  },
}));
